import {
  flexBox,
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
  responsiveFontSize,
} from "style/style_snippets"
import React from "react"

const ScoreTag = ({ icon, score }) => {
  const scoreTagStyle = {
    container: {
      ...flexBox.row,
      justifyContent: "flex-start",
      alignItems: "center",
      ...getMediaFor("marginRight", "20px", {
        [MEDIA_BREAKPOINT_KEYS.sm]: "30px",
      }),
    },

    score: {
      ...flexBox.row,
      justifyContent: "flex-start",
      alignItems: "center",
      arrow: {
        ...getMediaFor("marginLeft", "1px", {
          [MEDIA_BREAKPOINT_KEYS.sm]: "5px",
        }),
        content: "''",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        borderTop: "5px solid transparent",
        borderBottom: "5px solid transparent",
        borderRight: "5px solid black",
      },
      amount: {
        ...getMediaFor("padding", "2px 10px 2px 10px", {
          [MEDIA_BREAKPOINT_KEYS.sm]: "2px 15px 2px 15px",
        }),
        backgroundColor: "black",
        color: "white",
        fontWeight: 600,
        fontSize: responsiveFontSize(16, 20),
      },
    },
  }
  return (
    <div css={scoreTagStyle.container}>
      {icon}
      <div css={scoreTagStyle.score}>
        <div css={scoreTagStyle.score.arrow} />
        <div css={scoreTagStyle.score.amount}>{score}</div>
      </div>
    </div>
  )
}

export default ScoreTag
